// @flow
import styled from 'styled-components'
import * as colors from '../../theme/colors'

const OutlineButton = styled.a`
  background-color: ${colors.blue};
  font-family: avertaBold;
  color: ${colors.beige} !important;
  font-size: 16px;
  padding: 6px 18px;
  border: 3px solid ${colors.beige};
  cursor: pointer;
  display: inline-block;
  text-decoration: none;
  
  &:hover {
    text-decoration: none;
  }

  i {
    font-size: 24px;
  }
`

export default OutlineButton



// WEBPACK FOOTER //
// ./src/components/shared/OutlineButton.js